<template>
	<modal :withOkBtn="true" :withCancelBtn="true" @close="$emit('close')" @ok="spaceManager">
		<div slot="header">Spaces and Devices</div>
		<div slot="body">
			<div class="form-group">
				<button class="my-tab" :class="{'active': createSpace}" @click="createNewSpace">Create a new space</button>
				<button class="my-tab" :class="{'active': !createSpace}" @click="selectSpace">Select a space</button>
			</div>

			<div v-if="createSpace">
				<div class="form-group">
					<div class="form-label">Create a new space? Set a name:</div>
					<input type="text" name="spaceTitle" class="form-input" placeholder="Set a space name" v-model="spaceName" @input="message = ''"
						:class="{'input-error': attemptSubmit && isSpaceNameEmpty}">
					<div class="modal-message" v-if="attemptSubmit && isSpaceNameEmpty">Please enter a name for your new space.</div>
				</div>
			</div>
			<div v-else>
				<div class="form-group">
					<div class="form-label">Select a space:</div>
					<SelectBox :options="allSpaces" :placeholder="'Select space'" @change="updateSelectedSpace" :inputError="attemptSubmit && isChosenSpaceEmpty"/>
					<div class="modal-message" v-if="attemptSubmit && isChosenSpaceEmpty">Please choose a space from the list</div>
				</div>
				
			</div>
		</div>
	</modal>
</template>

<script>
	import Modal from './Modal';
	import SelectBox from '@/components/SelectBox';
	import {mapGetters} from 'vuex';

	export default {
		name: 'SpaceManagerModal',
		components: {
			'modal': Modal,
			SelectBox
		},
		computed: {
			...mapGetters(['allSpaces']),
			isSpaceNameEmpty: function() {
				return this.spaceName == '';
			},
			isSpacesEmpty: function() {
				return this.allSpaces.length == 0;
			},
			isChosenSpaceEmpty: function() {
				return this.chosenSpaceIndex === '';
			}
		},
		data() {
			return {
				file: '',
				message: '',
				spaceName: '',
				chosenSpaceIndex: '',
				createSpace: true,
				attemptSubmit: false
			}
		},
		methods: {
			spaceManager() {
				this.attemptSubmit = true;
				if (this.createSpace) {
					if(!this.isSpaceNameEmpty) {
						this.$emit('create-space', this.spaceName);
					}
				} else {
					if(!this.isChosenSpaceEmpty) {
						this.$emit('edit-space', this.chosenSpaceIndex);
					}
				}
			},
			updateSelectedSpace(index) {
				this.chosenSpaceIndex = index;
			},
			createNewSpace() {
				this.createSpace = true;
				this.attemptSubmit = false;
			},
			selectSpace() {
				this.createSpace = false;
				this.attemptSubmit = false;
			}
		}
	}
</script>
